// @flow
import React from 'react';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { ClusterInputTable } from '@components/cluster/cluster-input-table/ClusterInputTable';
import { TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { getIn, useFormikContext } from 'formik';
import { toastError } from '@presentational/notifications/utils';
import { useParams } from 'react-router-dom';
import { useUpdateTableFlowWorkloadMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { isAnythingEditedBesidesGivenFormBasedOnGivenConfig } from '@streaming-projects/utils';
import { FORM_NAMES } from '@streaming-projects/enums';
import { TABLEFLOW_WORKLOAD_DETAILS_CONFIG } from '@streaming-projects/workloads/tableflow-workloads/config';

import { useSPTableFlowContext } from '../contexts/SPTableFlowWorkloadContextProvider';

export const SPTableFlowWorkloadMonthlyUsageContainer = () => {
  const { orgId, spId, tableFlowWorkloadId } = useParams();
  const { values, initialValues } = useFormikContext();
  const [updateTableFlowWorkload] = useUpdateTableFlowWorkloadMutation();
  const spTableFlowWorkloadData = useSPTableFlowContext();

  const shouldFormBeDisabled = isAnythingEditedBesidesGivenFormBasedOnGivenConfig(
    initialValues,
    values,
    TABLEFLOW_WORKLOAD_DETAILS_CONFIG,
    FORM_NAMES.TABLE_FLOW.WORKLOAD_MONTHLY_USAGE_FORM
  );

  const rowsConfig = [
    {
      backendName: 'is_enabled',
      displayName: 'Active',
      isBooleanField: true,
    },
    {
      backendName: 'number_of_topics',
      displayName: 'Number of Topics',
    },
    {
      backendName: 'average_throughput_mbps',
      displayName: 'Average Throughput (Mbps)',
    },
  ];

  return (
    <PaddedAndRaisedSegment disabled={shouldFormBeDisabled}>
      <ClusterInputTable
        addCalendarMonthRowToDownload={false}
        disabled={false}
        inferTotalNumberOfMonthsFromDataset={true}
        keyNameInValues={TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES.MONTHLY_INPUTS}
        rowsConfig={rowsConfig}
        showYearNumberInMonthlyHeader={false}
        tableName="Tableflow Workload Monthly Usage"
        updateFunc={async () => {
          const valuesToSendToBackend = getIn(
            values,
            TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES.MONTHLY_INPUTS
          );
          const tableFlowInputs = Object.values(valuesToSendToBackend.months);
          const payload = {
            tableflow_resource_id: spTableFlowWorkloadData.tableflow_resource_id,
            tableflow_detail_id: spTableFlowWorkloadData.tableflow_detail_id,
            name: spTableFlowWorkloadData.name,
            sp_version: spTableFlowWorkloadData.sp_version,
            tableflow_usage_details: {
              id: spTableFlowWorkloadData.tableflow_details.id,
              inputs: tableFlowInputs,
            },
          };
          const { error } = await updateTableFlowWorkload({
            orgId,
            spId,
            tableFlowWorkloadId,
            payload,
          });
          if (error) {
            toastError(error);
          }
        }}
      />
    </PaddedAndRaisedSegment>
  );
};
